












































































































































































import { Component, Mixins, Watch } from 'vue-property-decorator'
import { mdiPencilOutline, mdiInformationOutline } from '@mdi/js'

import { mask } from 'vue-the-mask'

import type { BreadcrumbsItem } from '@/components/lib/Breadcrumbs.vue'

import { DisabledInput } from '@/components/lib/mixins/DisabledInput'
import Breadcrumbs from '@/components/lib/Breadcrumbs.vue'
import { security } from '@/store/modules/security'
import { claim } from '@/store/modules/claim'
import { Alert } from '@/mixins/Alert'
import { mock } from '@/tools'

@Component({
  directives: { mask },
  components: {
    Breadcrumbs,
  },
})
class ProfileForm extends Mixins<DisabledInput, Alert>(DisabledInput, Alert) {
  securityModule = security.context(this.$store)
  claimModule = claim.context(this.$store)

  icons = {
    mdiPencilOutline,
    mdiInformationOutline,
  }

  breadcrumbsItems: Array<BreadcrumbsItem> = [
    {
      text: 'Главная',
      disabled: false,
      to: { name: 'main' },
    },
    {
      text: this.$route.meta.title,
      disabled: true,
    },
  ]

  localEmailAccept = false
  localSmsAccept = false

  @Watch('securityModule.state.user', { deep: true, immediate: true })
  syncUserContacts() {
    this.localEmailAccept = this.securityModule.getters.userContacts.emailAccept
    this.localSmsAccept = this.securityModule.getters.userContacts.smsAccept
  }

  get userBirthDate() {
    return new Date(this.securityModule.getters.userToForm.birthDate).toLocaleDateString('RU-ru')
  }

  async created() {
    try {
      await this.claimModule.actions.getDocsType()
    } catch (error) {
      mock(error)
    }
  }

  async emailAcceptChange(emailAccept: boolean) {
    if (!emailAccept && !this.localSmsAccept) {
      this.openAlert({ type: 'error', message: 'Необходимо выбрать хотя бы один способ рассылки' })
      this.$nextTick(() => {
        this.localEmailAccept = true
      })
      return
    }

    try {
      this.localEmailAccept = emailAccept
      await this.securityModule.actions.changeUserContacts({ emailAccept })
      this.openAlert({ type: 'success', message: 'Согласие на рассылку успешно обновлено' })
    } catch (error) {
      this.localEmailAccept = !emailAccept
      mock(error)
    }
  }

  async smsAcceptChange(smsAccept: boolean) {
    if (!smsAccept && !this.localEmailAccept) {
      this.openAlert({ type: 'error', message: 'Необходимо выбрать хотя бы один способ рассылки' })
      this.$nextTick(() => {
        this.localSmsAccept = true
      })
      return
    }

    try {
      this.localSmsAccept = smsAccept
      await this.securityModule.actions.changeUserContacts({ smsAccept })
      this.openAlert({ type: 'success', message: 'Согласие на рассылку успешно обновлено' })
    } catch (error) {
      this.localSmsAccept = !smsAccept
      mock(error)
    }
  }
}

export default ProfileForm
